<h2 mat-dialog-title class="dialog-title">Neues Gebäude hinzufügen</h2>
<mat-dialog-content class="mat-typography dialog-content">
  <form [formGroup]="frmGebaeude">
    <!-- Standort ID (hidden) -->
    <div class="form-group">
      <input type="hidden" formControlName="standort_id" />
    </div>

    <!-- Gebäude Name -->
    <div class="form-group">
      <label class="form-label" for="name">Gebäude Name</label>
      <input
        type="text"
        class="form-control"
        id="name"
        formControlName="name"
        placeholder="Gebäude Name eingeben" />
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()">Abbrechen</button>
  <button mat-button (click)="onConfirm()" cdkFocusInitial>Erstellen</button>
</mat-dialog-actions>

